import { Form, Input, message } from 'antd';
import { ACTION_TITLE } from 'constants/constant';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { genreApiService } from 'service/api/genreApiService';
import * as Component from '../../../../shared/components';
import { I18nFormFields } from '../../../../shared/components/i18n/I18nFormFields';
import { I18nFieldData } from '../../../../shared/types/i18n/i18nTypes';
import { genreService } from '../services/genreService';

const GenreEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [i18nName, setI18nName] = useState<I18nFieldData>({});

  useEffect(() => {
    setIsLoading(true);
    genreApiService.fetchById(Number(id)).then(data => {
      // Initialize i18n data
      setI18nName(data.i18n_name || {});
      form.setFieldsValue({
        ...data,
        // Set legacy name from i18n_name.ko if available
        name: data.i18n_name?.ko || data.name || '',
      });
      setIsLoading(false);
    });
  }, [id, form]);

  return (
    <Component.BasePageComponent>
      {isLoading ? (
        <Component.LoadingSpinnerComponent />
      ) : (
        <div>
          <div className="people-details-page">
            <h1>Genre</h1>
            <Form form={form} layout="vertical" className="people-details-form">
              <I18nFormFields
                fieldName="name"
                required={true}
                fieldType="input"
                value={i18nName}
                onChange={value => setI18nName(value)}
                placeholder={{
                  ko: '장르 이름을 입력하세요',
                  en: 'Enter genre name',
                  'zh-hans': '请输入类型名称',
                  'zh-hant': '請輸入類型名稱',
                }}
              />
              <Form.Item
                style={{ marginTop: '10px' }}
                name="slug"
                label="Slug"
                rules={[{ required: true, message: 'please enter slug' }]}
              >
                <Input onChange={e => (e.target.value = e.target.value.toLowerCase())} />
              </Form.Item>
            </Form>
          </div>
          <div className="people-detail-update-button">
            <Component.ColorButtonComponent
              text={ACTION_TITLE.EDIT}
              onClick={async () => {
                const loadingMessage = message.loading('Updating...', 0);
                try {
                  // Validate form first
                  await form.validateFields();

                  // Get current form values
                  const formValues = form.getFieldsValue();

                  // Prepare complete genre data with i18n fields
                  const genreData = {
                    slug: formValues.slug || '',
                    i18n_name: i18nName || {},
                    // Legacy field: use ko value from i18n_name
                    name: i18nName?.ko?.toLowerCase() || '',
                  };

                  // Pass data directly to genreService
                  await genreService.updateGenre(Number(id), form, genreData);
                  loadingMessage();
                  navigate('/genre');
                } catch (error) {
                  loadingMessage();
                  console.error('Error updating genre:', error);
                }
              }}
            />
          </div>
        </div>
      )}
    </Component.BasePageComponent>
  );
};

export default observer(GenreEdit);
